import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
  Chip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import Header from "components/Header";

const ItService = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [breakdownData, setBreakdownData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [iconPath, setIconPath] = useState("");
  const [bannerPath, setBannerPath] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoryInput, setCategoryInput] = useState("");



  

  useEffect(() => {
    fetchBreakdownData();
  }, []);

  const fetchBreakdownData = async () => {
    try {
      const response = await axios.get(`${apiUrl}/itservices/getitservice`);
      setBreakdownData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching breakdown data:", error);
      setIsLoading(false);
    }
  };

  const handleOpenModal = (record = null) => {
    if (record) {
      setCurrentRecord(record);
      setTitle(record.title);
      setDescription(record.description);
      setIconPath(record.images?.icon || "");
      setBannerPath(record.images?.banner || "");
      setCategories(record.categories || []);
    } else {
      setCurrentRecord(null);
      setTitle("");
      setDescription("");
      setIconPath("");     
      setBannerPath("");
      setCategories([]);
    }
    setCategoryInput("");
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setCurrentRecord(null);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  
const handleImageUpload = async (file, type) => {
  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await axios.post(`${apiUrl}/upload`, formData);
    // const path = response.data.filePath;
    const path = response.data.url;
    if (type === "icon") setIconPath(path);
    else if (type === "banner") setBannerPath(path);
  } catch (error) {
    console.error("Error uploading image:", error);
    setErrorMessage("Error uploading image.");
    setSnackbarOpen(true);
  }
};

  // const handleFileChange = (event) => {
  //   const selectedImage = event.target.files[0];
    
  //   if (selectedImage) {
  //     handleImageUpload(selectedImage); // Automatically upload the image
  //   }
  // };
    const handleAddCategory = () => {
    const cat = categoryInput.trim();
    if (cat && !categories.includes(cat)) {
      setCategories((prev) => [...prev, cat]);
    }
    setCategoryInput("");
   };
   const handleCategoryKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddCategory();
    }
  };
    const handleCategoryDelete = (catToDelete) => {
    setCategories((prev) => prev.filter((cat) => cat !== catToDelete));
  };
  const handleSubmit = async () => {
    if (!title || !description || !iconPath || !bannerPath) {
      setErrorMessage("Please fill all the required fields.");
      setSnackbarOpen(true);
      return;
    }

    const postData = { title, description, images: {icon: iconPath, banner: bannerPath },categories };
    try {
      if (currentRecord) {
        const response = await axios.put(`${apiUrl}/itservices/updateitservice/${currentRecord._id}`, postData);
        setBreakdownData((prevData) =>
          prevData.map((item) => (item._id === currentRecord._id ? response.data : item))
        );
      } else {
        const response = await axios.post(`${apiUrl}/itservices/createitservice`, postData);
        setBreakdownData((prevData) => [...prevData, response.data]);
      }
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting data:", error);
      setErrorMessage("Error submitting data.");
      setSnackbarOpen(true);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${apiUrl}/itservices/deleteitservice/${id}`);
      setBreakdownData((prevData) => prevData.filter((item) => item._id !== id));
    } catch (error) {
      console.error("Error deleting data:", error);
      setErrorMessage("Error deleting data.");
      setSnackbarOpen(true);
    }
  };

  const columns = [
     
    { field: "title", headerName: "Title", flex: 1 },
    { field: "description", headerName: "Description", flex: 1 },
  {
  field: "images",
  headerName: "Icon",
  flex: 0.5,
  renderCell: (params) => (
    // <img src={`${apiUrl}/${params.row.images?.icon}} alt={params.row.title} width="50" height="50" />
    <img
          src={params.row.images?.icon}
          alt={params.row.title}
          width="50"
          height="50"
        />
  ),
},

    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      renderCell: (params) => (
        <>
          <Button variant="contained"  style={{marginRight: 8}} color="primary" size="small" onClick={() => handleOpenModal(params.row)}>
            Update
          </Button>
          <Button variant="contained" color="secondary" size="small" onClick={() => handleDelete(params.row._id)}>
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="IT SERVICES" subtitle="Manage IT Services" />
      <Button variant="contained" color="primary" onClick={() => handleOpenModal(null)}>
        Add New Record
      </Button>

      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>{currentRecord ? "Update Record" : "Add New Record"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Title"
            type="text"
            fullWidth
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Description"
            type="text"
            fullWidth
            variant="outlined"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Add Category"
            type="text"
            fullWidth
            variant="outlined"
            value={categoryInput}
            onChange={(e) => setCategoryInput(e.target.value)}
            onKeyDown={handleCategoryKeyDown}
          /> 
            <Box mt={2} display="flex" gap={1} flexWrap="wrap">
            {categories.map((cat, index) => (
              <Chip
                key={index}
                label={cat}
                onDelete={() => handleCategoryDelete(cat)}
                color="primary"
              />
            ))}
          </Box>

        <Button variant="contained" component="label" sx={{ mt: 2 }}>
  Upload Icon
  <input type="file" hidden accept="image/*" onChange={(e) => handleImageUpload(e.target.files[0], "icon")} />
</Button>
{iconPath && (
  <Typography variant="body2" sx={{ mt: 1 }}>
    {/* <img src={`${apiUrl}/${iconPath}`} alt="icon" width="50" height="50" /> */}
    <img src={iconPath} alt="image" width="50" height="50" />
  </Typography>
)}
<br />

<Button variant="contained" component="label" sx={{ mt: 2 }}>
  Upload Banner
  <input type="file" hidden accept="image/*" onChange={(e) => handleImageUpload(e.target.files[0], "banner")} />
</Button>
{bannerPath && (
  <Typography variant="body2" sx={{ mt: 1 }}>
    {/* <img src={`${apiUrl}/${bannerPath}`} alt="banner" width="100" height="50" /> */}
    <img src={bannerPath} alt="image" width="50" height="50" />
  </Typography>
)}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary">
            {currentRecord ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Box mt="40px" height="75vh">
        <DataGrid
          loading={isLoading}
          getRowId={(row) => row._id}
          rows={breakdownData || []}
          columns={columns}
          pageSize={5}
        />
      </Box>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ItService;